import { render, staticRenderFns } from "./ListadoPorHacer.vue?vue&type=template&id=b10648d2&"
import script from "./ListadoPorHacer.vue?vue&type=script&lang=js&"
export * from "./ListadoPorHacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports